// extracted by mini-css-extract-plugin
export default {"tx":"_6b303144ac","line":"_9a2825c581"};